import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';

import { environment } from 'src/environments/environment';

import { Language } from '../models/classes/language';
import { TranslateService } from '@ngx-translate/core';
import { UiService } from './ui.service';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    languageChanged = new Subject<string>();

    private baseUrl: string = environment.apiUrl + 'languages';
    private selectedLang: string;

    constructor(
        private http: HttpClient,
        private translateSrv: TranslateService,
    ) { }

    getList(): Observable<Language[]> {
        return this.http.get<Language[]>(this.baseUrl);
    }

    setCurrentLanguage(selLanguage: string): Observable<void> {
        if(selLanguage == null) {
            selLanguage = this.translateSrv.getBrowserLang();
        }

        if(selLanguage !== this.selectedLang) {
            return this.translateSrv.use(selLanguage)
            .pipe(
                map(() => {
                    this.selectedLang = selLanguage;
                    this.languageChanged.next(selLanguage);
                })
            );
        }

        return of(null);
    }

    getCurrentLanguageCode(): string {
        return this.selectedLang || this.translateSrv.getBrowserLang();
    }
}
